<ngx-spinner>
</ngx-spinner>

<!-- CARDS -->
<div class="test-info-card-container custom-margin">

  <!-- progress card -->
  <div class="test-info-card progress-card" *ngIf="filteredProgress$ | async as progress">
    <div class="card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="20" x2="12" y2="10"></line>
        <line x1="18" y1="20" x2="18" y2="4"></line>
        <line x1="6" y1="20" x2="6" y2="16"></line>
      </svg>
    </div>
    <div class="card-content">
      <div class="d-flex align-items-center gap-2">
        <h3 class="card-value mb-0">{{progress.completedCriteria}}/{{progress.totalCriteria}}</h3>
        <span class="spinner-border text-primary" *ngIf="progress.completedCriteria < progress.totalCriteria"
          style="width: 1.5rem; height: 1.5rem;">
        </span>
      </div>
      <p class="card-label mb-0">Scenarios Generated</p>
    </div>
  </div>

</div>

<app-testbook></app-testbook>

<!-- Session Chat removed - handled by parent StoryComponent -->